<template>
 <svg :style="style"  width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="&#229;&#164;&#167;&#229;&#176;&#143;&#231;&#177;&#187;&#229;&#158;&#139;=&#229;&#164;&#167;40, &#231;&#167;&#145;&#229;&#174;&#164;&#229;&#144;&#141;&#231;&#167;&#176;=&#230;&#149;&#180;&#229;&#189;&#162;&#231;&#190;&#142;&#229;&#174;&#185;">
<g id="Frame">
<path id="Vector" d="M21.076 18.7392C23.9323 15.909 28.8903 11.7552 33.3727 11.7552C34.3776 11.7445 35.3695 11.982 36.2603 12.4454L36.2734 12.4523C37.5801 13.1945 37.9355 15.1163 37.3319 18.1563C36.6809 21.4385 34.3179 27.7086 31.5581 28.0487C31.0886 28.1077 30.6168 28.1421 30.1442 28.1513C31.1392 30.4132 30.9775 32.3641 29.667 33.6846C28.6375 34.7401 27.2205 35.3314 25.7453 35.3199C24.0303 35.2219 22.3881 34.6375 21.004 33.6486C21.459 31.9719 21.7562 29.1961 21.7562 26.0549C21.7562 23.0815 21.4896 20.4358 21.076 18.7392ZM18.988 33.6624C17.6062 34.6436 15.9671 35.2226 14.2559 35.3192C12.7815 35.3306 11.3637 34.7401 10.3342 33.6831C9.0229 32.3626 8.86205 30.414 9.85856 28.146C9.38596 28.1375 8.91413 28.1046 8.4446 28.0464C5.68409 27.7071 3.32188 21.4354 2.67081 18.154C2.06647 15.1147 2.41422 13.2006 3.70486 12.4622C4.60562 11.9896 5.60903 11.746 6.62698 11.7552C11.1017 11.7552 16.0552 15.9006 18.9145 18.73C18.5001 20.4259 18.2328 23.0761 18.2328 26.0549C18.2328 29.2045 18.5315 31.9872 18.988 33.6624ZM19.9998 19.4217C20.5161 19.4217 20.9358 22.4312 20.9358 26.1422C20.9358 29.8548 20.5161 32.8627 19.9998 32.8627C19.4836 32.8627 19.0646 29.8548 19.0646 26.1422C19.0646 22.4312 19.4836 19.4217 19.9998 19.4217ZM13.7243 5.9332C15.869 8.51294 17.2853 10.9625 17.9823 14.554C18.0627 14.9692 18.4641 15.2396 18.8785 15.1592C19.2929 15.0787 19.564 14.6774 19.4836 14.263C18.7276 10.3658 17.1957 7.71558 14.9009 4.95507C14.6305 4.6303 14.1487 4.58588 13.8239 4.85626C13.4992 5.12588 13.4547 5.60843 13.7243 5.9332ZM26.2753 5.9332C24.1306 8.51294 22.7144 10.9625 22.0174 14.554C21.9369 14.9692 21.5356 15.2396 21.1212 15.1592C20.7068 15.0787 20.4357 14.6774 20.5161 14.263C21.2721 10.3658 22.8048 7.71558 25.0996 4.95507C25.3692 4.6303 25.8517 4.58588 26.1765 4.85626C26.5013 5.12588 26.5449 5.60843 26.2753 5.9332Z" fill="white"/>
</g>
</g>
</svg>






</template>

<script>
export default {
  name: 'icon-zxwk',
  props: {
    fontSize: {
      type: String,
      default: '18px'
    },
    color: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        cursor: 'pointer',
        'font-size': this.fontSize
      }
    }
  }
}
</script>